import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiJson } from '../lib/api.js';

const card = {
  background: '#fff',
  borderRadius: 18,
  padding: '32px 36px',
  boxShadow: '0 18px 48px rgba(20, 5, 60, 0.08)',
  border: '1px solid var(--border, #ece8f6)',
  maxWidth: 440,
  margin: '60px auto',
};
const input = {
  width: '100%', padding: '10px 12px', borderRadius: 10,
  border: '1px solid var(--border, #d8d6e6)', marginBottom: 18, fontSize: 14.5,
  boxSizing: 'border-box',
};
const primaryBtn = {
  width: '100%', padding: '12px 16px', borderRadius: 10, border: 'none',
  background: 'linear-gradient(135deg, #5b21b6, #7c3aed)', color: '#fff',
  fontSize: 15, fontWeight: 700, cursor: 'pointer',
};

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setSubmitting(true);
    try {
      await apiJson('/api/auth/forgot-password', { method: 'POST', body: { email: email.trim() } });
      setSent(true);
    } catch (e2) {
      // The endpoint returns success even for unknown emails (no enumeration),
      // so an error here is a network/server issue.
      setErr(e2.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mm-auth-page" style={{ padding: 24, minHeight: '100vh', background: 'var(--bg, #f7f5fc)' }}>
      <div className="mm-auth-card" style={card}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#5b21b6', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 8 }}>
          Account recovery
        </div>

        {sent ? (
          <>
            <h1 style={{ margin: '0 0 10px', fontSize: 24, color: '#15803d' }}>Check your inbox</h1>
            <p style={{ color: '#4b4361', lineHeight: 1.6, fontSize: 14.5 }}>
              If an account exists for <strong>{email.trim()}</strong>, we've sent a password-reset
              link. It expires in 60 minutes. Check your spam/junk folder if you don't see it.
            </p>
            <Link to="/login" style={{ display: 'inline-block', marginTop: 18, color: '#5b21b6', fontWeight: 600 }}>
              ← Back to sign in
            </Link>
          </>
        ) : (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 24 }}>Forgot your password?</h1>
            <p style={{ color: '#6b7280', lineHeight: 1.6, fontSize: 14, margin: '0 0 18px' }}>
              Enter the email you signed up with and we'll send you a link to set a new password.
            </p>

            {err && (
              <div className="mm-auth-error" style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '8px 12px', fontSize: 13.5, marginBottom: 12 }}>
                {err}
              </div>
            )}

            <form onSubmit={submit} noValidate>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                autoFocus
                placeholder="you@example.com"
                style={input}
              />
              <button type="submit" className="mm-auth-primary" disabled={submitting || !email.trim()} style={{ ...primaryBtn, opacity: submitting || !email.trim() ? 0.6 : 1 }}>
                {submitting ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <div style={{ marginTop: 16, fontSize: 13.5 }}>
              <Link to="/login" style={{ color: '#5b21b6' }}>← Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
